import React, { useRef, useState } from "react";
import "./PrivacyPolicy.css";

const policyData = {
  introduction: {
    title: "Introduction",
    content: [
      "At sandip electronics  And Automation, accessible from https://official.seaiot.in/, we respect your privacy and are committed to protecting the information shared by users and visitors.",
      "This Privacy Policy explains how information is collected, used, stored, and protected when you interact with our website, products, or services.",
      "If you have any questions regarding this policy, please contact us using the details provided below.",
    ],
  },

  scope: {
    title: "Scope of This Policy",
    content: [
      "This Privacy Policy applies only to information collected through our website and online platforms.",
      "It does not apply to information collected offline or through channels not directly linked to this website.",
    ],
  },

  consent: {
    title: "Consent",
    content: [
      "By accessing or using our website, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.",
    ],
  },

  information: {
    title: "Information We Collect",
    content: [
      "We collect personal information only when you voluntarily submit a form through the Career / Apply section of our website.",
      "This information may include:",
    ],
    list: [
      "Name",
      "Email address",
      "Phone number",
      "Resume or CV",
      "Educational and professional details",
      "Any information you choose to include in your application",
    ],
  },

  purpose: {
    title: "Purpose of Data Collection",
    content: [
      "Information submitted through the Career / Apply form is used solely for:",
    ],
    list: [
      "Reviewing job applications",
      "Recruitment and hiring communication",
      "Contacting applicants regarding their application",
    ],
  },
  Retention: {
    title: "Data Storage and Retention",
    content: [
      "Data Storage and Retention",
    ],
    list: [
      "•	Applicant information is stored temporarily and only for the duration necessary to complete the recruitment process.",
      "•	We do not maintain long-term storage or backups of applicant data.",
      "•	Once the recruitment purpose is fulfilled, the data is deleted or securely disposed of within a reasonable period.",
    ],
  },

  cookies: {
    title: "Cookies and Tracking Technologies",
    content: [
      "Our website may use cookies or similar technologies to:",
    ],
    list: [
      "Store user preferences",
      "Improve site performance",
      "Enhance browsing experience",
      "You can choose to disable cookies through your browser settings.",
      "Disabling cookies may affect certain website features.",
    ],
  },

  thirdParty: {
    title: "Third-Party Services",
    content: [
      "We may use third-party service providers for hosting, analytics, communication, or technical support.",
      "These providers are contractually required to protect information and use it only for authorized purposes.",
      "We do not control the privacy practices of external websites linked from our platform.",
    ],
  },

  security: {
    title: "Data Storage and Security",
    content: [
      "We implement reasonable administrative, technical, and organizational measures to protect information from unauthorized access, disclosure, alteration, or destruction.",
      "However, no method of data transmission or storage is completely secure, and absolute security cannot be guaranteed.",
    ],
  },

  rights: {
    title: "User Rights",
    content: [
      "Depending on applicable laws, you may have the right to:",
    ],
    list: [
      "Request access to your submitted information",
      "Request correction or deletion of your information",
      "Requests can be made using the contact details below, and we aim to respond within 30 days.",
    ],
  },

  ccpa: {
    title: "CCPA Privacy Rights (California Residents)",
    content: [
      "California residents may have the right to:",
    ],
    list: [
      "Know what personal data is collected",
      "Request deletion of personal data",
      "Opt out of the sale of personal data (if applicable)",
      "We do not sell personal information.",
    ],
  },

  gdpr: {
    title: "GDPR Data Protection Rights (EU Residents)",
    content: [
      "Users covered by the GDPR have rights including:",
    ],
    list: [
      "Access",
      "Rectification",
      "Erasure",
      "Restriction of processing",
      "Objection to processing",
      "Data portability",
    ],
  },

  children: {
    title: "Children’s Privacy",
    content: [
      "Our website is not intended for individuals under the age of 13, and we do not knowingly collect personal data from children.",
      "If such data is identified, it will be promptly removed.",
    ],
  },

  updates: {
    title: "Policy Updates",
    content: [
      "We may update this Privacy Policy from time to time.",
      "Any changes will be posted on this page with an updated effective date.",
    ],
  },

  law: {
    title: "Governing Law",
    content: [
      "This Privacy Policy shall be governed and interpreted in accordance with the laws of [Country / State].",
    ],
  },

  contact: {
    title: "Contact Information",
    content: [
      "For privacy-related inquiries, please contact:",
      "sandip electronics  And Automation",
      "Address: S No 116, R Cube, Office No 211, AtulNagar Phase I,Warje, Pune, Maharashtra 411058",
      "Email: [support@seaiot.in]",
      "Phone: [8055607812]",
    ],
  },

  acceptance: {
    title: "Acceptance",
    content: [
      "By using our website or services, you acknowledge that you have read, understood, and agreed to this Privacy Policy.",
    ],
  },
};

const PrivacyPolicy = () => {
  const [activeSection, setActiveSection] = useState("introduction");

  const sectionRefs = useRef(
    Object.keys(policyData).reduce((acc, key) => {
      acc[key] = React.createRef();
      return acc;
    }, {})
  );

  const handleSidebarClick = (key) => {
    setActiveSection(key);
    const ref = sectionRefs.current[key];
    if (ref && ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="privacy-wrapper">
      {/* HERO */}
      <section className="hero-section">
        <h1>Privacy Policy</h1>
        <p>Effective JAN 1, 2026</p>
      </section>

      {/* CONTENT */}
      <div className="privacy-content">
        <section className="content-section">
          {/* LEFT SIDEBAR */}
          <aside className="sidebar">
            <ul>
              <li
                className={activeSection === "introduction" ? "active" : ""}
                onClick={() => handleSidebarClick("introduction")}
              >
                Introduction
              </li>
              <li
                className={activeSection === "scope" ? "active" : ""}
                onClick={() => handleSidebarClick("scope")}
              >
                Scope of This Policy
              </li>
              <li
                className={activeSection === "consent" ? "active" : ""}
                onClick={() => handleSidebarClick("consent")}
              >
                Consent
              </li>
              <li
                className={activeSection === "information" ? "active" : ""}
                onClick={() => handleSidebarClick("information")}
              >
                Information We Collect
              </li>
              <li
                className={activeSection === "purpose" ? "active" : ""}
                onClick={() => handleSidebarClick("purpose")}
              >
                Purpose of Data Collection
              </li>
              <li
                className={activeSection === "Retention" ? "active" : ""}
                onClick={() => handleSidebarClick("Retention")}
              >
                Data Storage and Retention
              </li>
              <li
                className={activeSection === "cookies" ? "active" : ""}
                onClick={() => handleSidebarClick("cookies")}
              >
                Cookies and Tracking Technologies
              </li>
              <li
                className={activeSection === "thirdParty" ? "active" : ""}
                onClick={() => handleSidebarClick("thirdParty")}
              >
                Third-Party Services
              </li>
              <li
                className={activeSection === "security" ? "active" : ""}
                onClick={() => handleSidebarClick("security")}
              >
                Data Storage and Security
              </li>
              <li
                className={activeSection === "rights" ? "active" : ""}
                onClick={() => handleSidebarClick("rights")}
              >
                User Rights
              </li>
              <li
                className={activeSection === "ccpa" ? "active" : ""}
                onClick={() => handleSidebarClick("ccpa")}
              >
                CCPA Privacy Rights
              </li>
              <li
                className={activeSection === "gdpr" ? "active" : ""}
                onClick={() => handleSidebarClick("gdpr")}
              >
                GDPR Data Protection Rights
              </li>
              <li
                className={activeSection === "children" ? "active" : ""}
                onClick={() => handleSidebarClick("children")}
              >
                Children’s Privacy
              </li>
              <li
                className={activeSection === "updates" ? "active" : ""}
                onClick={() => handleSidebarClick("updates")}
              >
                Policy Updates
              </li>
              <li
                className={activeSection === "law" ? "active" : ""}
                onClick={() => handleSidebarClick("law")}
              >
                Governing Law
              </li>
              <li
                className={activeSection === "contact" ? "active" : ""}
                onClick={() => handleSidebarClick("contact")}
              >
                Contact Information
              </li>
              <li
                className={activeSection === "acceptance" ? "active" : ""}
                onClick={() => handleSidebarClick("acceptance")}
              >
                Acceptance
              </li>
            </ul>
          </aside>

          {/* RIGHT CONTENT: show ALL sections */}
          <main className="policy-content">
            {Object.entries(policyData).map(([key, section]) => (
              <section
                key={key}
                ref={sectionRefs.current[key]}
                className="policy-section-blockpc"
              >
                <h2>{section.title}</h2>

                {section.content &&
                  section.content.map((text, index) => (
                    <p key={index}>{text}</p>
                  ))}

                {section.list && (
                  <ul>
                    {section.list.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </main>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
